import React from 'react';
import GeneralStyles from './../styles/GeneralStyles'


class BaseSizeSensitiveComponent extends React.Component {

    constructor(props) {
        super();

        this.state = {
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };

        this.styler = new GeneralStyles();

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions(event) {
        this.styler.setWidth(document.documentElement.clientHeight);
        this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }
}

export default BaseSizeSensitiveComponent



// WEBPACK FOOTER //
// src/components/BaseSizeSensitiveComponent.js